import React from "react";
import { Typography, TypographyProps } from "@mui/material";
const TypoGraphyKit: React.FC<TypographyProps> = ({
  children,
  variant,
  ...props
}) => {
  return (
    <Typography variant={variant} {...props}>
      {children}
    </Typography>
  );
};

export default TypoGraphyKit;
